function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 88.934,
  y: 86.346,
  width: 84.225,
  height: 4.975,
  rx: 2.488,
  transform: "rotate(180 88.934 86.346)",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 2.132
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -1.066,
  y: 1.066,
  width: 79.961,
  height: 53.662,
  rx: 4.62,
  transform: "matrix(-1 0 0 1 85.735 26.642)",
  fill: "#d2eedd",
  stroke: "#000",
  strokeWidth: 2.132
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -1.066,
  y: 1.066,
  width: 75.696,
  height: 65.745,
  rx: 2.488,
  transform: "matrix(-1 0 0 1 83.604 12.427)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: -1.066,
  y: 1.066,
  width: 75.696,
  height: 65.745,
  rx: 2.488,
  transform: "matrix(-1 0 0 1 83.604 12.427)",
  fill: "#3D72DF",
  fillOpacity: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -1.066,
  y: 1.066,
  width: 75.696,
  height: 65.745,
  rx: 2.488,
  transform: "matrix(-1 0 0 1 83.604 12.427)",
  stroke: "#000",
  strokeWidth: 2.132
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#img-webinars_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.646 45.467h12.176a5.975 5.975 0 100-11.95H64.646a5.975 5.975 0 100 11.95z",
  fill: "#1FA956"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.417 26.828a4.998 4.998 0 109.786-2.044 4.998 4.998 0 00-9.786 2.044z",
  fill: "#FFDB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.726 21.426a2.078 2.078 0 004.066-.849 2.078 2.078 0 00-4.066.85z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.976 20.15a1.265 1.265 0 102.477-.517 1.265 1.265 0 00-2.477.517z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.086 28.71s1.019-.29.92-1.238",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.472 26.985c.3-.002.54-.39.536-.865-.003-.475-.248-.86-.547-.857-.299.002-.539.389-.536.864.003.476.248.86.547.858zM63.947 26.985c.299-.002.539-.39.536-.865-.003-.475-.248-.86-.547-.857-.3.002-.54.389-.536.864.003.476.248.86.547.858z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.425 25.154a1.816 1.816 0 103.553-.745 1.816 1.816 0 00-3.553.745z",
  fill: "#FFDB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.244 23.021s1.968.744 4.99-.487l.834 2.904 1.826-.824s.14-1.805 1.912-1.545c0 0-.565-3.39-2.676-3.639-3.69-.434-6.426 1.724-6.886 3.591z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.43 88.116s1.979 2.507.659 6.795c-1.32 4.289-5.212 6.466-5.212 6.466L79.324 89.541a10.479 10.479 0 01-5.665-7.862l-1.99-13.753-9.748 15.141L74.26 98.886s.623 3.909-2.104 6.938c-3.58 3.975-7.165 2.826-7.165 2.826L49.156 89.67A10.477 10.477 0 0148.14 77.7l11.173-19.252a14.693 14.693 0 0127.225 5.101l2.154 13.747 18.738 10.82z",
  fill: "#1FA956"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.496 96.787c-.626-3.208-3.729-4.434-6.417-5.533-1.126-.461-2.284-.999-3.084-1.95-.831-.991-1.142-2.281-1.09-3.555.06-1.421.556-2.757 1.107-4.053.619-1.453 1.409-2.954 1.496-4.561.142-2.618-2.015-4.81-4.463-5.37-3.13-.716-6.202 1.507-8.268 3.614-.129.131-.376-.045-.263-.203 1.544-2.144 4.185-3.877 6.856-4.11 2.486-.217 5.07 1.26 6.173 3.497 1.428 2.9-.437 5.728-1.434 8.429-.55 1.488-.902 3.167-.362 4.713.512 1.463 1.819 2.275 3.17 2.868 1.487.652 3.013 1.18 4.329 2.161 1.322.987 2.29 2.315 2.558 3.966.035.203-.267.293-.308.087z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.393 89.021c1.51-2.505 2.232-5.45 1.622-8.352-.15-.708-.38-1.473-1-1.91-.79-.559-1.555-.078-2.212.44-1.138.898-2.062 2.01-2.89 3.192-.124.176-.377.027-.287-.167.706-1.517 1.87-2.852 3.245-3.804.592-.41 1.273-.662 1.98-.4.677.249 1.141.842 1.405 1.492.608 1.492.607 3.307.37 4.876-.26 1.721-.913 3.396-1.957 4.795-.119.162-.386.02-.276-.162zM86.599 63.574c-.651.939-1.412 1.694-2.47 2.162a5.574 5.574 0 01-3.103.41 5.807 5.807 0 01-2.994-1.435c-.871-.794-1.394-1.842-1.846-2.912-.47-1.112-.892-2.273-1.694-3.198a6.807 6.807 0 00-2.637-1.85c-1.955-.772-4.22-.702-6.037.394-1.137.686-2.129 1.653-3.422 2.052-1.066.329-2.379.072-3.107-.81-.171-.208.094-.482.298-.298 2.127 1.904 4.392-.623 6.219-1.611 1.638-.887 3.604-1.03 5.39-.547 1.759.476 3.362 1.567 4.328 3.128 1.245 2.01 1.53 4.533 3.702 5.863 2.434 1.492 5.468.692 7.166-1.503.092-.12.291.034.207.155zM84.654 58.324c-2.099 1.068-4.367.621-6.174-.796-1.757-1.38-3.444-3.77-3.486-6.067-.003-.151.198-.158.247-.033.817 2.06 1.664 4.016 3.378 5.502.747.646 1.626 1.158 2.586 1.403 1.149.294 2.239.06 3.366-.207.116-.027.197.14.083.198zM56.634 62.877c1.27-.2 2.593-.107 3.853.124 1.125.206 2.285.534 3.245 1.176 1.733 1.16 2.331 3.247 1.991 5.237-.374 2.192-1.917 3.92-3.646 5.209-2.008 1.495-4.343 2.555-6.656 3.483-2.77 1.113-5.619 2.018-8.418 3.053-.338.124-.47-.403-.147-.533 4.398-1.775 9.041-3.005 13.166-5.405 1.84-1.07 3.645-2.422 4.624-4.367.863-1.713.914-4.06-.413-5.56-.843-.954-2.089-1.402-3.29-1.71-1.412-.363-2.826-.422-4.276-.453-.137-.006-.181-.232-.033-.254z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.513 65.104c1.512 1.277 1.536 3.44.476 5.02-.53.79-1.267 1.433-2.084 1.915-.816.483-1.907.98-2.874.918-.279-.017-.315-.374-.063-.472.827-.32 1.674-.455 2.469-.89a6.37 6.37 0 001.836-1.483c1.166-1.393 1.382-3.428-.064-4.705-.208-.183.095-.479.304-.303z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.745 61.123l.747 6.916",
  stroke: "#fff",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.076 44.69s-3.81 11.245-8.941 13.262c-5.132 2.017-18.663-7.649-18.663-7.649-1.192-.088-3.16 0-6.074-2.968",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.83 39.441l-6.083 9.802M52.894 50.302l-12.785-6.344s-2.483-5.59-4.272-6.698",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.98 54.958s-4.113-.165-3.824.538c.29.702 6.74 1.674 6.74 1.674",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.98 54.958s-4.113-.165-3.824.538c.29.702 6.74 1.674 6.74 1.674",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.405 45.54c-.46 3.294-.797 6.192-.797 6.192s-13.46 2.372-15.101 4.193l5.402 4.353s11.855.543 15.109-3.416c1.865-2.27 3.224-7.377 4.043-11.323H73.73",
  fill: "#d2eedd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.11 36.53C67.1 38.859 65.606 51.73 65.606 51.73s-13.46 2.372-15.1 4.194l5.401 4.352s11.855.543 15.109-3.416c3.254-3.959 4.965-16.55 4.965-16.55",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.11 36.53c-.53 1.224-1.194 5.36-1.704 9.01m9.577-5.23s-.312 2.293-.922 5.23",
  stroke: "#fff",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.39 52.794s3.238-.4 4.85.53l14.264 8.238a1.837 1.837 0 01-1.837 3.18L45.205 56.39c-1.596-.922-2.815-3.595-2.815-3.595z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.755 61.29s-1.015.937-1.86.421c-.56-.342-.062-.803.337-1.073-.543.3-1.532.752-2.003.372-.668-.538.632-1.584.632-1.584s-1.272.727-1.963.224c-.69-.503.438-1.38.438-1.38 1.441-.726 1.847-1.38 1.703-2.766l8.37 4.525-5.654 1.262z",
  fill: "#d2eedd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.185 60.256l-5.429 1.035s-1.014.936-1.859.42.714-1.298.714-1.298-1.712 1.136-2.38.597c-.668-.538.631-1.584.631-1.584s-1.271.727-1.962.224c-.691-.503.437-1.38.437-1.38 1.428-.72 1.826-1.305 1.703-2.766",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.404 25.429c-1.453.257-3.404.134-4.59-1.118-1.187-1.253-.223-3.686 2.163-2.698.1-2.16 2.334-2.652 3.19-.966.854 1.686.076 3.673-.763 4.782zM5.85 16.071c-.934.165-2.196.145-2.958-.66-.762-.804-.143-2.366 1.39-1.732.063-1.386 1.498-1.702 2.047-.62.549 1.083.058 2.3-.48 3.012zM12.615 18.525c-.631.01-1.33-.203-1.733-.8-.405-.595.185-1.535 1.114-.968.205-.885 1.182-.939 1.414-.186.232.753-.359 1.553-.795 1.954z",
  fill: "#EC7EB0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.682 49.876c2.908 0 4.118-.554 6.486-1.525 3.031-2.069 4.347-3.547 6.024-6.574 2.947-6.39.594-14.084-5.611-17.667-1.774-1.024-3.351-.749-4.873.096l-.483-.748a9.396 9.396 0 01-1.45-5.94c.117-1.302-1.165-2.202-2.389-2.021-1.224.18-2.122.948-2.252 2.14-.319 2.916.62 5.843 2.22 8.323l.675 1.049c-1.867 1.583-3.822 3.132-6.12 3.31l-.24.024a6.45 6.45 0 00-5.38 4.374 12.474 12.474 0 00-5.592-1.126c-1.841.059-2.432 1.474-2.29 2.498.16 1.155 1.264 1.93 2.726 1.939 1.362.008 2.74.36 4.004 1.089l1.352.78c1.01 4.123 3.715 6.706 5.97 8.069l.084.042c2.568 1.273 3.768 1.868 7.139 1.868z",
  fill: "#F5BED7"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.168 48.35c-2.368.972-3.578 1.526-6.486 1.526-3.408 0-4.597-.608-7.224-1.91M10.489 39.897l-1.352-.78a8.083 8.083 0 00-4.004-1.09c-1.462-.008-2.565-.783-2.726-1.938-.142-1.023.449-2.44 2.29-2.498 1.88-.06 3.793.302 5.593 1.126a6.45 6.45 0 015.379-4.374l.24-.023c2.298-.179 4.253-1.728 6.12-3.311l-.676-1.049c-1.599-2.48-2.538-5.407-2.219-8.323.13-1.192 1.028-1.96 2.252-2.14 1.224-.18 2.506.72 2.39 2.021a9.396 9.396 0 001.45 5.94l.482.748c1.522-.845 3.1-1.12 4.873-.096 6.205 3.583 8.558 11.277 5.611 17.667",
  fill: "#FFAFA4"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#img-webinars_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.028 27.009s6.892 5.7 4.2 7.538-7.158-5.41-8.287-4.833",
  fill: "#EC7EB0"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M36.524 40.884s-3.792-4.26-4.78-4.056c-.988.205 4.853 8.396 4.853 8.396",
  fill: "#d2eedd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M36.524 40.884s-3.792-4.26-4.78-4.056c-.988.205 4.853 8.396 4.853 8.396",
  stroke: "#000",
  strokeWidth: 0.429,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M56.867 0h20.8a4.164 4.164 0 014.16 4.16v5.546a4.164 4.164 0 01-4.16 4.16H60.213l-5.14 5.14a1.387 1.387 0 01-2.367-.98V4.16A4.164 4.164 0 0156.867 0zM72.12 7.626c0 .383.31.694.693.694H74.2c.382 0 .693-.31.693-.694V6.24a.693.693 0 00-.693-.693h-1.387a.693.693 0 00-.693.693v1.386zm-5.547 0c0 .383.31.694.694.694h1.386c.383 0 .694-.31.694-.694V6.24a.693.693 0 00-.694-.693h-1.387a.693.693 0 00-.693.693v1.386zm-5.546 0c0 .383.31.694.693.694h1.387c.383 0 .693-.31.693-.694V6.24a.693.693 0 00-.693-.693H61.72a.693.693 0 00-.693.693v1.386z",
  fill: "#FFDB00"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M72.12 7.627c0 .383.31.693.693.693h1.386c.383 0 .694-.31.694-.693V6.24a.693.693 0 00-.694-.693h-1.386a.693.693 0 00-.694.693v1.387zm-5.547 0c0 .383.31.693.693.693h1.387c.383 0 .693-.31.693-.693V6.24a.693.693 0 00-.693-.693h-1.387a.693.693 0 00-.693.693v1.387zm-5.547 0c0 .383.31.693.694.693h1.386c.383 0 .694-.31.694-.693V6.24a.693.693 0 00-.694-.693H61.72a.693.693 0 00-.694.693v1.387z",
  fill: "#000"
});

function SvgImgWebinars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "img-webinars_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 79,
    height: 69
  }, _ref3, _ref4, _ref5), _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("mask", {
    id: "img-webinars_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 15,
    width: 36,
    height: 35
  }, _ref9), _ref10, _ref11, _ref12, _ref13, _ref14);
}

export default __webpack_public_path__ + "static/img-webinars.b8b761b6.svg";
export { SvgImgWebinars as ReactComponent };